import { useCallback } from 'react';
import withRouter from 'helpers/withRouter';
import { Menu } from 'antd';
import { FolderOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { ROUTES } from 'const';
import Styles from './FoldersMenuItem.module.css';

export const FoldersMenuItem = withRouter(
  ({ isSelected, children, name, navigate, location, ...props }) => {
    const onChangeFolder = useCallback(() => {
      const newPath = `${ROUTES.DOCUMENTS_CABINET}/${name}`;

      if (location.pathname === newPath) {
        navigate(ROUTES.DOCUMENTS_CABINET);

        return;
      }

      navigate(newPath);
    }, [navigate, name]);

    return (
      <Menu.Item {...props} onClick={onChangeFolder}>
        {isSelected ? (
          <FolderOpenOutlined className={Styles.Icon} />
        ) : (
          <FolderOutlined className={Styles.Icon} />
        )}
        {children}
      </Menu.Item>
    );
  }
);
